export function getIndex(element) {
  const siblings = element.parentNode.children;
  let index = 0;

  for (let i = 0; i < siblings.length; i++) {
    if (siblings[i] == element) return index;
    index++;
  }

  return -1;
}


export function hasClass(element, cls) {
  return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
}

export function isAppleSafari(userAgent) {
  let iPhone = userAgent.match(/iPhone/i) !== null;
  let Mac = userAgent.match(/Mac/i) !== null;
  let iPod = userAgent.match(/iPod/i) !== null;
  let iOS = userAgent.match(/iOS/i) !== null;
  let Safari = userAgent.match(/Safari/i) !== null;
  return Safari && (iPhone || Mac || iPod || iOS);
}

export function activateNoScroll() {
  document.body.classList.add('no-scroll');
  document.documentElement.classList.add('no-scroll');
  
  let stickyBanner = document.querySelector('[data-component="sticky-banner"]');
  if (stickyBanner) {
    stickyBanner.classList.add('hidden');
  }

  let header = document.querySelector('[data-element="header"]');
  if (header) {
    header.classList.add('hidden');
  }
}

export function removeNoScroll(isMobile = false) {
  document.body.classList.remove('no-scroll');
  document.documentElement.classList.remove('no-scroll');

  let stickyBanner = document.querySelector('[data-component="sticky-banner"]');
  if (stickyBanner) {
    stickyBanner.classList.remove('hidden');
  }

  let header = document.querySelector('[data-element="header"]');

  if(header) {
    header.classList.remove("hidden");
  }
}

export function empty(node) {
  if (!node) return;
  node.replaceChildren();
}

export function getElementRect(selector) {
  const element = document.querySelector(selector);
  if (!element) return 0;
  return element.getBoundingClientRect();
}
